'use client';

import { c as _c } from "react/compiler-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { useGenerateGardenStyle } from '@/store/generate';
export const gardenStyles = [{
  id: 'same-as-original',
  label: 'Same as original',
  emoji: '🔄'
}, {
  id: 'modern-minimalist',
  label: 'Modern Minimalist',
  emoji: '🧘'
}, {
  id: 'cottage',
  label: 'Cottage',
  emoji: '🏡'
}, {
  id: 'japanese',
  label: 'Japanese',
  emoji: '⛩️'
}, {
  id: 'luxury',
  label: 'Luxury',
  emoji: '💎'
}, {
  id: 'natural',
  label: 'Natural & Green',
  emoji: '🌿'
}, {
  id: 'child-friendly',
  label: 'Child-Friendly',
  emoji: '🧸'
}, {
  id: 'low-maintenance',
  label: 'Low-Maintenance',
  emoji: '🧹'
}, {
  id: 'mediterranean',
  label: 'Mediterranean',
  emoji: '🌴'
}, {
  id: 'native-pollinator',
  label: 'Native Pollinator',
  emoji: '🦋'
}, {
  id: 'zen-minimalist',
  label: 'Zen Minimalist',
  emoji: '🧘‍♀️'
}, {
  id: 'tropical',
  label: 'Tropical',
  emoji: '🌺'
}, {
  id: 'prairie-meadow',
  label: 'Prairie Meadow',
  emoji: '🌾'
}, {
  id: 'contemporary-modern',
  label: 'Contemporary Modern',
  emoji: '🏗️'
}, {
  id: 'xeriscaping',
  label: 'Xeriscaping',
  emoji: '🌵'
}, {
  id: 'forest-woodland',
  label: 'Forest Woodland',
  emoji: '🌲'
}, {
  id: 'edible-kitchen',
  label: 'Edible Kitchen',
  emoji: '🥬'
}, {
  id: 'coastal-nautical',
  label: 'Coastal Nautical',
  emoji: '🌊'
}, {
  id: 'industrial-modern',
  label: 'Industrial Modern',
  emoji: '🏭'
}, {
  id: 'bohemian-naturalistic',
  label: 'Bohemian Naturalistic',
  emoji: '🌸'
}];
export const getGardenStyleDisplay = id => {
  const style = gardenStyles.find(s => s.id === id);
  return style ? `${style.emoji} ${style.label}` : id;
};
export function GardenStyleSelect() {
  const $ = _c(6);
  const {
    gardenStyle,
    setGardenStyle
  } = useGenerateGardenStyle();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Label htmlFor="gardenStyle" className="mb-1.5 block text-sm font-semibold text-gray-700">Garden style</Label>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SelectTrigger id="gardenStyle" className="w-full"><SelectValue placeholder="Select style" /></SelectTrigger>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SelectContent>{gardenStyles.map(_temp)}</SelectContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== gardenStyle || $[4] !== setGardenStyle) {
    t3 = <div>{t0}<Select name="gardenStyle" value={gardenStyle} onValueChange={setGardenStyle}>{t1}{t2}</Select></div>;
    $[3] = gardenStyle;
    $[4] = setGardenStyle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(style) {
  return <SelectItem key={style.id} value={style.id}>{style.emoji} {style.label}</SelectItem>;
}